import request from '@/utils/request'

const customsDeclarationContractApi = {
  trade_customs_declaration_contract_list: '/trade/customs_declaration_contract/',
  trade_customs_declaration_contract_create: '/trade/customs_declaration_contract/',
  trade_customs_declaration_contract_update: '/trade/customs_declaration_contract/',
  trade_customs_declaration_contract_delete: '/trade/customs_declaration_contract/',
  trade_customs_declaration_contract_archived: '/trade/customs_declaration_contract_archived/',
  trade_customs_declaration_contract_attachment: '/trade/customs_declaration_contract_attachment/'
}

/**
 * 列表
 */
export function customs_declaration_contract_list (parameter) {
  return request({
    url: customsDeclarationContractApi.trade_customs_declaration_contract_list,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}
/**
 * 添加
 */
export function customs_declaration_contract_create (parameter) {
  return request({
    url: customsDeclarationContractApi.trade_customs_declaration_contract_create,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 修改
 */
export function customs_declaration_contract_update (parameter, customs_declaration_contract_id) {
  return request({
    url: customsDeclarationContractApi.trade_customs_declaration_contract_update + customs_declaration_contract_id + '/',
    method: 'put',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 删除
 */
export function customs_declaration_contract_delete (customs_declaration_contract_id) {
  return request({
    url: customsDeclarationContractApi.trade_customs_declaration_contract_delete + customs_declaration_contract_id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function customs_declaration_contract_archived (parameter) {
  return request({
    url: customsDeclarationContractApi.trade_customs_declaration_contract_archived,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

/**
* 担保合同附件列表
* @param parameter
* @returns {AxiosPromise}
*/
export function customs_declaration_contract_attachment_list (parameter) {
  return request({
    url: customsDeclarationContractApi.trade_customs_declaration_contract_attachment,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}

/**
 * 担保合同附件添加
 */
export function customs_declaration_contract_attachment_create (parameter) {
  return request({
    url: customsDeclarationContractApi.trade_customs_declaration_contract_attachment,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

/**
 * 担保合同附件删除
 */
export function customs_declaration_contract_attachment_delete (contract_attachment_id) {
  return request({
    url: customsDeclarationContractApi.trade_customs_declaration_contract_attachment + contract_attachment_id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
